<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "CloudMiningConfig",
        components: {CommonTable},
        data() {
            return {
                type: 0,// type 为 1 是成功云矿，为 2 是一键结算云矿
                agentVisible: false,
                form: {
                    agentId: null,
                },
                agentList: [],
                searchs: [/*, {
                    name: 'type',
                    placeholder: '请选择状态',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: '货币'
                    },{
                        key: 1,
                        value: '购买平台'
                    },{
                      key: 2,
                      value: '销售平台'
                    },{
                      key: 3,
                      value: '买入价'
                    }]
                }*/],
              permission: {
                add: 'cloudMiningConfig:add',
                update: 'cloudMiningConfig:update',
                delete: 'cloudMiningConfig:delete',
                deleteBatch: 'cloudMiningConfig:deleteBatch'
              },
              url: {
                get: '/cloudMiningConfig/listByCondition',
                add: '/cloudMiningConfig/add',
                update: '/cloudMiningConfig/update',
                delete: '/cloudMiningConfig/delete/',
                delete_batch: '/cloudMiningConfig/deleteBatch',
              },
              tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                field: 'current',
                label: '币种',
                show: true,
                width: '',
              }, {
                field: 'currentName',
                label: '货币名称',
                show: true,
                width: '',
              }, {
                field: 'amount',
                label: '买入价',
                show: true,
                width: '',
              }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
              formFields: {
                addTitle: '添加订单',
                updateTitle: '修改订单',
                labelWidth: '105px',
                model: [{
                  field: 'current',
                  label: '币种',
                  type: 'input',
                  placeholder: '币种',
                  rules: [{message: '请输入币种', trigger: 'blur', required: true}],
                  add: true,
                  update: true,
                },{
                  field: 'currentName',
                  label: '货币名称',
                  type: 'input',
                  placeholder: '货币名称',
                  rules: [{message: '请输入货币名称', trigger: 'blur', required: true}],
                  add: true,
                  update: true,
                },{
                  field: 'amount',
                  label: '买入价',
                  type: 'input',
                  placeholder: '买入价',
                  rules: [{message: '请输入买入价', trigger: 'blur', required: true}],
                  add: true,
                  update: true,
                }],
              },
                operate: [],
                buttons: []
            }
        },

    }
</script>

<style scoped>

</style>
